export default __webpack_public_path__ + "static/media/730C.d99d0c51.jpg";